import React from 'react';
import type { QueryMode } from '../../types';

export interface HeaderProps {
  queryMode: QueryMode;
  onQueryModeChange: (mode: QueryMode) => void;
}

/**
 * 顶部居中标题（悬浮于地图之上，不拦截指针事件）
 */
export function Header(props: HeaderProps): React.ReactElement {
  const { queryMode, onQueryModeChange } = props;
  return (
    <header className="dash-title-bar">
      <h1 className="dash-title-bar__text">零碳园区数字化平台</h1>
      <div className="dash-title-bar__controls">
        <button
          type="button"
          className={
            queryMode === 'parks'
              ? 'dash-mode-switch__btn dash-mode-switch__btn--active'
              : 'dash-mode-switch__btn'
          }
          onClick={() => onQueryModeChange('parks')}
        >
          园区查询
        </button>
        <button
          type="button"
          className={
            queryMode === 'policies'
              ? 'dash-mode-switch__btn dash-mode-switch__btn--active'
              : 'dash-mode-switch__btn'
          }
          onClick={() => onQueryModeChange('policies')}
        >
          政策查询
        </button>
        <button
          type="button"
          className={
            queryMode === 'docking'
              ? 'dash-mode-switch__btn dash-mode-switch__btn--active'
              : 'dash-mode-switch__btn'
          }
          onClick={() => onQueryModeChange('docking')}
        >
          工作管理
        </button>
        <button
          type="button"
          className={
            queryMode === 'profiles'
              ? 'dash-mode-switch__btn dash-mode-switch__btn--active'
              : 'dash-mode-switch__btn'
          }
          onClick={() => onQueryModeChange('profiles')}
        >
          园区专题
        </button>
      </div>
    </header>
  );
}
